import {alias, list, createModelSchema} from "serializr";

import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {MapKindLiteModel} from "@/modules/mutils/models/MapKindLiteModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {Schema} from "@/common/Schema";
import {MapGroupModel} from "@/modules/redactor/models/map/MapGroupModel";

export class SmartOfferBundleExpeditionGroup extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.EXPEDITION_GROUP);

        this._maps = [];
        this._mapGroup = null;

        this._rewards = null;
    }

    get maps() {
        return this._maps;
    }

    set maps(value) {
        this._maps = value;
    }

    get mapGroup() {
        return this._mapGroup;
    }

    set mapGroup(value) {
        this._mapGroup = value;
    }

    get rewards() {
        return this._rewards;
    }

    set rewards(value) {
        this._rewards = value;
    }

    valid() {
        if (!super.valid()) {
            return false;
        }

        if (this.maps.length === 0) {
            return false;
        }

        if(!this.mapGroup || MapGroupModel.isNone(this.mapGroup)) {
            return false;
        }

        if(!this.mapGroup.key || this.mapGroup.key === "map_group_global" || this.mapGroup.key === "map_group_main") {
            return false;
        }

        for(const map of this.maps) {
            const mapKind = RedactorUtils.getMapKindByCode(map.code);
            if(!this.mapGroup || !this.mapGroup.key || !mapKind.group || mapKind.group.key !== this.mapGroup.key) {
                return false;
            }
        }

        if(this.rewards && this.rewards.length > 0){
            if(!this.rewards.valid()){
                return false;
            }

            if(this.rewards.length !== this.maps.length){
                return false;
            }
        }

        return true;
    }

    empty() {
        if (this.maps.length === 0) {
            return true;
        }

        if(!this.mapGroup || MapGroupModel.isNone(this.mapGroup)) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleExpeditionGroup());
        } else if (target instanceof SmartOfferBundleExpeditionGroup) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleExpeditionGroup, {
    _maps: alias("maps", list(MapKindLiteModel.schema())),

    _mapGroup: alias("map_group", MapGroupModel.schema()),

    _rewards: alias("rewards", RewardBunch.schema()),
});